/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useContext } from "react";
import cn from "classnames";
import FlexibleSpaceModal from "components/componentLibrary/Modals/FlexibleSpaceModal";
import QueryManagerContext from "context/QueryManager/QueryManagerContext";
import { track, eventCategories, analyticsEvents } from "util/analytics";
import styles from "./style.module.scss";

interface IProps {
  className?: string;
  onSignUp: Function;
}

const FlexibleSpaceCard = ({ className = "", onSignUp = () => {} }: IProps) => {
  const [showSignUpModal, toggleSignUpModal] = useState(false);
  const context = useContext(QueryManagerContext);
  const searchContextValues = context.values;
  const { submarkets, market, neighborhoods, numEmployees } =
    searchContextValues;

  const trackOpen = () =>
    track(analyticsEvents.flex_modal_open, {
      category: eventCategories.flex_card,
      label: "",
    });

  const trackClose = () =>
    track(analyticsEvents.flex_modal_close, {
      category: eventCategories.flex_card,
      label: "",
    });

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <>
      <div
        className={cn(styles.card, className)}
        onClick={() => {
          trackOpen();
          toggleSignUpModal(true);
        }}
      >
        <div className={styles.imageContainer}>
          <div className={`${styles.image} card-image`}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src="https://www.squarefoot.com/wp-content/uploads/2019/09/Image1-768x705.jpg"
              alt="short term turnkey spaces"
            />
          </div>
        </div>
        <div className={styles.inner}>
          <p className={`${styles.title}`}>
            Interested in short term, move in ready spaces?
          </p>
          <p className={styles.subtitle}>
            Turnkey solutions with flexible: Terms | Sizing | Services
          </p>
          <p className={styles.pricing}>$ Flexible</p>
          <p className={cn(styles.details, styles.iconPanel)}>
            <i className={cn("icon", "icon-layout")} />
            <span className={styles.squarefeet}>∞ sf</span>
            <i className={cn("icon", "icon-user")} />
            <span className={styles.maxOccupancy}>∞</span>
            <button className={`btn-primary ${styles.button}`}>
              View Flexible Listings
            </button>
          </p>
        </div>
      </div>
      {showSignUpModal && (
        <FlexibleSpaceModal
          submarkets={submarkets}
          market={market.externalId}
          neighborhoods={neighborhoods}
          numberOfEmployees={parseInt(numEmployees, 10)}
          onClose={() => {
            trackClose();
            toggleSignUpModal(false);
          }}
          onConfirm={() => onSignUp()}
        />
      )}
    </>
  );
};

export default FlexibleSpaceCard;
